export const Footer = () => {
    return (
        <footer className='Footer'>
            Assignment by <a href='https://www.theodinproject.com/paths/full-stack-javascript/courses/javascript/lessons/shopping-cart' 
                             target='_blank' 
                             rel='noreferrer'>The Odin Project</a>. 
            Coded by <a href='https://github.com/stanochka'
                        target='_blank' 
                        rel='noreferrer'>stanochka</a>.
        </footer>
    )
}